// ** React Imports
import { renderRoutes } from "react-router-config";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import Nav from "components/layout/Nav";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";
import { CardsBlockWrapper } from "components/layout/Card/CardsBlockWrapper";

// ** Menu Items
import { UserFriendsNavSectionFriendsItem } from "./UserFriendsNavSection/menu-items/user-friends-nav-section-friends-item";
import { UserFriendsNavSectionFollowersItem } from "./UserFriendsNavSection/menu-items/user-friends-nav-section-followers-item";
import { UserFriendsNavSectionFollowingsItem } from "./UserFriendsNavSection/menu-items/user-friends-nav-section-followings-item";

// ** Utils & Helpers
import processRoutes from "utils/processRoutes";
import containerRoutes from "helpers/containerRoutes";

// #####################################################

const Friends = ({ route: { routes } }) => {
	const user = useSelector((state) => state.userProfileMain);

	const processedRoutes = processRoutes(routes);
	const finalRoutes = containerRoutes(processedRoutes, {
		login: user.login.toLowerCase(),
	});

	// #####################################################

	return (
		<CardsBlockWrapper>
			<CardWrapper>
				<CardBody>
					<Nav.Panel appearance="tabs" noLine>
						<Nav.List noPad>
							{/* Friends */}
							<UserFriendsNavSectionFriendsItem />
							{/* Followers */}
							<UserFriendsNavSectionFollowersItem />
							{/* Followings */}
							<UserFriendsNavSectionFollowingsItem />
						</Nav.List>
					</Nav.Panel>
					{renderRoutes(finalRoutes)}
				</CardBody>
			</CardWrapper>
		</CardsBlockWrapper>
	);
};

// #####################################################

export default Friends;

// #####################################################
